import { EyeOutlined } from "@ant-design/icons";
import { MazakaButton } from "apps/Common/MazakaButton";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { useState } from "react";
import endPoints from "../EndPoints";
import { useQueryClient } from "react-query";
import { allReadNotificationList } from "../Services";

const ReadAllNotifications = () => {
  const [isLoading, setisLoading] = useState(false);
  const queryClient = useQueryClient();
  const handleReadAllNotifications = async () => {
    setisLoading(true);
    try {
      await allReadNotificationList();
      openNotificationWithIcon("default","İşlem Başarılı")
      queryClient.resetQueries({
        queryKey: endPoints.getNotificationList,
        exact: false,
      });
    } catch (error: any) {
      openNotificationWithIcon("default", error?.message);
    } finally {
      setisLoading(false);
    }
  };
  return (
    <>
      <MazakaButton
        loading={isLoading}
        disabled={isLoading}
        onClick={handleReadAllNotifications}
        className="!bg-black !text-white"
        icon={<EyeOutlined />}
      >
        Tüm Bildirimleri Okundu Yap
      </MazakaButton>
    </>
  );
};

export default ReadAllNotifications;
